import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

import { KeyboardKey, KeystrokeHandler } from '../utilities/keystroke-handler.utility';
import { InputDialogService } from './../services/input-dialog.service';

import './input-dialog.component.css';

export interface InputDialogModel {
    title?: string;
    placeholder?: string;
    componentArea?: string;
    inputValidator?: (input: string) => InputValidationResult;
    dismissAction?: () => void;
    inputButtonModel?: InputButtonModel;
}

export interface InputButtonModel {
    executeAction(inputText: string): void;
    text: string;
}

export interface InputValidationResult {
    isValid: boolean;
    message: string;
}

@Component({
    selector: 'ohp-input-dialog',
    templateUrl: './input-dialog.component.html'
})
export class InputDialogComponent implements OnInit {
    @ViewChild('dialogInputField') public inputFieldElement: ElementRef;

    public inputDialogModel: InputDialogModel;
    public showDialog: boolean = false;
    public inputText: string = '';
    public inputValidationResult: InputValidationResult;

    public constructor(private readonly inputDialogService: InputDialogService) {
    }

    @HostListener('window:keydown', ['$event'])
    public keyEvent(event: KeyboardEvent) {
        if (KeystrokeHandler.getKey(event) === KeyboardKey.Escape) {
            this.onDismiss();
        }
    }

    public ngOnInit() {
        this.inputDialogService.inputDialog.subscribe((inputDialogModel: InputDialogModel) => {
            if (inputDialogModel) {
                this.reset();
                this.inputDialogModel = inputDialogModel;
                this.showDialog = true;
            }
        });
        this.checkInputText(this.inputText);
    }

    public onClickInputTextButton() {
        if (this.inputValidationResult.isValid) {
            this.executeAction();
        }
    }

    public handleInputKeyEvent(event: KeyboardEvent) {
        if (KeystrokeHandler.getKey(event) === KeyboardKey.Enter && this.inputValidationResult.isValid) {
            this.executeAction();
        } else if (KeystrokeHandler.getKey(event) === KeyboardKey.Escape) {
            this.onDismiss();
        }
    }

    public onInputChange(event: string) {
        this.checkInputText(event);
    }

    public onDismiss() {
        this.showDialog = false;
        if (this.inputDialogModel && this.inputDialogModel.dismissAction) {
            this.inputDialogModel.dismissAction();
        }
    }

    private executeAction() {
        this.showDialog = false;
        this.inputDialogModel.inputButtonModel.executeAction(this.inputText);
    }

    private reset() {
        this.inputText = '';
        this.checkInputText(this.inputText);
    }

    private checkInputText(text) {
        if (this.inputDialogModel && this.inputDialogModel.inputValidator) {
            this.inputValidationResult = this.inputDialogModel.inputValidator(text);
        } else {
            this.inputValidationResult = {
                isValid: false,
                message: ''
            };
        }
    }
}
